// To generate a new file similar to this one, run `pay js:run gql-v1 --type=lazy-query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1QueryOptionsWithoutVariables,
  V1QueryOptions,
  V1QueryReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1Query} from '@stripe-internal/data-v1';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1CryptoInternalPayinSessionInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

import {payinSessionFragment} from 'src/api/graphql/payinSessionFragment';

import type {
  PayinSessionFragmentData,
  PayinSessionFragmentToken,
} from 'src/api/graphql/payinSessionFragment';

const doc = gql`
  query PayinSessionQuery(
    $input: OpenapiGetV1CryptoInternalPayinSessionInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalPayinSession(input: $input, v1Context: $v1Context) {
      id
      ...PayinSessionFragment
    }
  }
  ${payinSessionFragment}
`;

export const payinSessionQuery: PayinSessionQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const payinSessionQueryOptions: V1QueryOptionsWithoutVariables<PayinSessionQueryDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function usePayinSessionQuery(
  options: V1QueryOptions<PayinSessionQueryDocument>,
): V1QueryReturn<PayinSessionQueryDocument> {
  return useV1Query(payinSessionQuery, {
    ...payinSessionQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type PayinSessionQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1CryptoInternalPayinSessionInput>;
  v1Context: V1ContextInput;
}>;

export type PayinSessionQueryData = {
  readonly __typename: 'Query';
  readonly v1CryptoInternalPayinSession: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinSession';
      readonly id: string;
    },
    [PayinSessionFragmentData]
  > | null;
};

export type PayinSessionQueryToken = PayinSessionFragmentToken &
  AccountToken<{Query_v1CryptoInternalPayinSession: true}>;

// Temporarily duplicating the token type to facilitate migration.
// This will be removed as part of go/rename-permissions-to-token work.
export type PayinSessionQueryPermissions = PayinSessionQueryToken;

export type PayinSessionQueryDocument = GraphQlDocument<
  PayinSessionQueryData,
  PayinSessionQueryVariables,
  PayinSessionQueryToken
>;
